import React, { useState } from 'react';
import { Image, View } from 'react-native';

export default ({ source, style, resizeMode, C, rotate, borderRadius, backgroundColor }) => {
  const [scaleImage, setScale] = useState(1);
  if (source?.uri) {
    Image.getSize(source.uri, (width, height) => {
      const wh = width / height;
      if (wh >= 100 || wh <= 0.01) {
        return setScale(1.45);
      }
      if (wh >= 20 || wh <= 0.05) {
        return setScale(1.25);
      }
    });
  }

  return (
    <View
      style={[
        { width: '100%', height: '100%', backgroundColor: backgroundColor ?? C('Picture/Light/Underlay'), overflow: 'hidden' },
        borderRadius && { borderRadius },
      ]}
    >
      <View
        style={[
          {
            width: '100%',
            height: '100%',
            backgroundColor: backgroundColor ? 'transparent' : C('Picture/Dark/Overlay'),
            position: 'absolute',
            zIndex: 10,
          },
          borderRadius && { borderRadius },
        ]}
      />
      <Image
        style={{
          ...style,
          transform: [
            { scale: scaleImage },
            {
              rotate: `${rotate || 0}deg`,
            },
          ],
        }}
        resizeMode={resizeMode}
        source={{
          ...source,
        }}
      />
    </View>
  );
};
